"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcCardPrimaryBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_card_primary_constants_1 = require("./bc-card-primary-constants");
var BcCardPrimaryBehavior = (function (_super) {
    __extends(BcCardPrimaryBehavior, _super);
    function BcCardPrimaryBehavior() {
        return _super.call(this) || this;
    }
    BcCardPrimaryBehavior.setUpAll = function () {
        var imgElements = Array.from(document.querySelectorAll("[class^='".concat(bc_card_primary_constants_1.CARD_PRIMARY, "']")));
        var elements = [];
        for (var _i = 0, imgElements_1 = imgElements; _i < imgElements_1.length; _i++) {
            var element = imgElements_1[_i];
            var bc = new BcCardPrimaryBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    };
    BcCardPrimaryBehavior.prototype._setUp = function () {
        _super.prototype._setUp.call(this);
        this.setColorPositionCard();
    };
    BcCardPrimaryBehavior.prototype.setColorPositionCard = function () {
        this.cardElement = this.mySelf;
        if (this.cardElement.classList.contains(bc_card_primary_constants_1.CARD_PRIMARY)) {
            var positionCard = this.mySelf.getAttribute("data-position")
                ? this.mySelf.getAttribute("data-position")
                : "horizontal";
            this.cardElement = this.mySelf;
            this.mySelf.classList.add("bc-card-primary-".concat(positionCard));
            if (this.mySelf.getAttribute("data-border") === "true") {
                this.mySelf.classList.add("bc-card-primary-color-".concat(positionCard));
            }
        }
    };
    return BcCardPrimaryBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcCardPrimaryBehavior = BcCardPrimaryBehavior;
